import Container from './container'
import GovPersonnelView from './views'

export { GovPersonnelView }

export default Container



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/index.js